import PropTypes from 'prop-types';
import React from 'react';
import CompareStocks from '../CompareStocks/CompareStocks';
import Container from '../Container/Container';
import PriceChart from '../PriceChart/PriceChart';
import StockFollowButton from '../StockFollowButton/StockFollowButton';
import StockHeader from '../StockHeader/StockHeader';
import EarningsCall from '../EarningsCall/EarningsCall';
import style from './StockPage.module.css';
import About from '../About/About';
import RevenueSources from '../RevenueSources/RevenueSources';
import ShareStatistics from '../ShareStatistics/ShareStatistics';
import ValuationAndMultiples from '../ValuationAndMultiples/ValuationAndMultiples';
import Return from '../Return/Return';
import AnalystOneYearPriceTarget from '../AnalystOneYearPriceTarget/AnalystOneYearPriceTarget';
import CurrentFairValue from '../CurrentFairValue/CurrentFairValue';
import StockDetails from '../StockDetails/StockDetails';
import InsiderTrades from '../InsiderTrades/InsiderTrades';
import News from '../News/News';
// import StockFeed from '../StockFeed/StockFeed';
import PolymarketTile from '../PolymarketTile/PolymarketTile';
import NextEarnings from '../NextEarnings/NextEarnings';
import InstitutionalOwnership from '../InstitutionalOwnership/InstitutionalOwnership';
import InstitutionalSentiment from '../InstitutionalSentiment/InstitutionalSentiment';

const StockPage = (props) => {
  const account = props.current_user ?? props.currentUser;
  const followingStock =
    typeof account?.following_stock === 'boolean'
      ? account.following_stock
      : typeof account?.followingStock === 'boolean'
        ? account.followingStock
        : undefined;

  const hasEarningsData = Boolean(props.next_earnings || props.last_earnings);

  const followControl =
    props.stock?.symbol != null && props.stock.symbol !== '' ? (
      <StockFollowButton
        symbol={props.stock.symbol}
        displayName={props.stock.name}
        sessionSignedIn={Boolean(account)}
        initialFollowing={followingStock}
        iconSrc={props.add_alert_icon_url}
      />
    ) : null;

  return (
    <div className={style.pageContainer}>
      <StockHeader
        stock={props.stock}
        currentUser={account}
        alertIconUrl={props.add_alert_icon_url}
        rightSection={followControl}
        showStockFollow={false}
      />

      <Container>
        <PriceChart stock={props.stock} hubGurus={props.hub_gurus} />

        <div className={style.flexGrid}>
          <CompareStocks stock={props.stock} metricPercentiles={props.metric_percentiles} />
        </div>

        <div className={`${style.flexGrid} ${style.boxes}`}>
          <EarningsCall earnings_call_transcript={props.earnings_call_transcript} stock={props.stock} current_user={account} />
          <News stock={props.stock} />
        </div>

        <div className={`${style.flexGrid} ${style.boxes}`}>
          <AnalystOneYearPriceTarget stock={props.stock} price_target_summary={props.price_target_summary} price={props.price} />
          <CurrentFairValue discounted_cash_flows={props.discounted_cash_flows} price_target={props.price_target} price={props.price} stock={props.stock} />
        </div>

        <InsiderTrades stock={props.stock} />

        <StockDetails stock={props.stock} />

        <div className={style.flexGrid}>
          <div>
            <ShareStatistics share_statistics={props.share_statistics} />
            <Return stock={props.stock} return_of_company={props.return_of_company} price={props.price} />
          </div>
          <ValuationAndMultiples valuation={props.valuation} stock={props.stock} />
        </div>

        <div className={style.lowerGrid} data-testid="stock-lower-grid">
          <div className={style.lowerGridCell} data-testid="stock-lower-grid-revenue">
            <RevenueSources stock={props.stock} />
          </div>
          {hasEarningsData ? (
            <div className={style.lowerGridCell} data-testid="stock-lower-grid-earnings">
              <NextEarnings next_earnings={props.next_earnings} last_earnings={props.last_earnings} />
            </div>
          ) : null}
          <div className={style.lowerGridCell} data-testid="stock-lower-grid-sentiment">
            <InstitutionalSentiment data={props.institutional_ownership} />
          </div>
          <div className={style.lowerGridCell} data-testid="stock-lower-grid-ownership">
            <InstitutionalOwnership data={props.institutional_ownership} />
          </div>
          <PolymarketTile stock={props.stock} />
          <div className={style.lowerGridCell} data-testid="stock-lower-grid-about">
            <About about={props.about} stock={props.stock} />
          </div>
        </div>
        {/* <StockFeed stock={props.stock} /> */}
      </Container>


    </div>
  );
};

// this is passed from the Rails view
StockPage.propTypes = {
  stock: PropTypes.object.isRequired,
  metric_percentiles: PropTypes.array.isRequired,
  earnings_call_transcript: PropTypes.object,
};

export default StockPage;
